import moment from "moment";
export const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
}


export const formatDateTime = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    return moment(date).format(format)
}

export const formatDateExam = (date, format = 'DD/MM/YYYY') => {
    return moment(date).format(format)
}
export const convertDateTimeToUTC = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    return moment.utc(moment(date)).format(format)

}
export const timeToLocate = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    return moment(date + '+00:00').local().format(format);
}
export const dateTimeToLocate = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    return moment(date).local().format(format);
}
export const formatLocalTimeDate = (date, format = 'HH:mm:ss DD/MM/YYYY') => {
    return moment(date + '+00:00').local().format(format);
}
